<template>
	<tbody style="background:var(--grey-3);">
		<tr v-if="this.order">
			<td v-if="this.order?.canBeEdited">
				<div class="flexcenter">
					<Circle fileName="w3_trash_white" color="darkgrey" @click="deleteOrderRow" />
				</div>

			</td>
			<td v-if="this.debug">
				{{ orderRow.orderRowId }}<br />
				PID: {{ orderRow.productId }}<br />
				POSID: {{ orderRow.productOptionSetId }}
			</td>
			<td>
				{{ this.formatArtnr(orderRow.artnr) }}



			</td>
			<td>

				<div v-if="this.order?.canBeEdited" class="flexcenter">

					<div v-if="!this.showChangeQuantity" class="link" @click="this.changeQuantity();"
						style="width:40px;text-align:center;background: var(--grey-4);padding:5px;">
						{{ this.orderRow.quantity }}
					</div>

					<div v-if="this.showChangeQuantity" class="flexcenter">
						<Circle fileName="w3_close_white" padding="25%" color="--grey-5" @click="this.showChangeQuantity = false" />
						<input type="text" v-model="this.newQuantity" size="3" style="padding:5px;" @keydown="this.updated = true"
							@keyup.enter="this.updateQuantity" />
						<Button label="OK" :class="this.updated ? '' : 'grey'" @click="this.updateQuantity" />
					</div>

				</div>
				<div v-if="!this.order?.canBeEdited" 
					style="width:40px;text-align:center;background: var(--grey-4);padding:5px;">
					{{ this.orderRow.quantity }}
				</div>
			</td>

			<td>{{ orderRow.product }}

				<div v-if="this.orderRow.noInStock == 0"
					style="font-weight:bold;font-size:80%;color:grey;padding-top:3px;padding:5px;background:var(--grey-4);border-radius: 3px;; ">
					{{ this.orderRow.deliveryTime
					}}</div>

			</td>
			<td>
				<div class="noInStock" :class="'noInStock_' + orderRow.noInStockKey"
					style="color:white;padding:5px;border-radius: 5px;text-align:center;width:30px;">
					{{ this.noInStockSymbol(orderRow.noInStockKey) }}
				</div>


			</td>
			<td v-if="this.debug">{{ orderRow.currentStock }}</td>
			<td>{{ orderRow.price }}</td>
			<td v-if="this.order?.canBeEdited">
				<Circle v-if="this.spinner" fileName="w3_spinner_white" :spinning="this.spinner" color="grey" size="30px" />
			</td>
		</tr>

	</tbody>
</template>
<script>
import { userMixin } from '@/mixins/userMixin';
import { productMixin } from '@/mixins/productMixin';
import { USER_STORE_ACTION, USER_STORE_GETTER } from '@/store/user-store';



export default {
	name: "OrderRow",
	components: {},
	mixins: [userMixin, productMixin],
	props: {
		orderRow: Object,
		orderId: Number,

	},
	data() {
		return {
			newQuantity: 0,
			spinner: false,
			updated: false,
			showChangeQuantity: false,

		};
	},
	computed: {

		order() {

			const orderList = this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST_INDEXED]

			const order = orderList[this.orderId];

			return order;

		}

	},
	
	methods: {
		changeQuantity(){

			this.showChangeQuantity = true
			this.newQuantity = this.orderRow.quantity
			this.updated = false



		},
		deleteOrderRow() {

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd och orderraden kan inte raderas");
				return;
			}

			if (!window.confirm("Vill du radera orderraden?")){
				return;
			}

			this.order.meta.updating = true
			this.spinner = true;

			const data = { orderRowId: this.orderRow.orderRowId, currentOrderId: this.orderId }
			this.$store.dispatch({ type: USER_STORE_ACTION.DELETE_ORDER_ROW, data: data });

		},
		updateQuantity() {

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd och orderraden kan inte ändras");
				return;
			}

			this.order.meta.updating = true
			this.spinner = true;

			const data = { currentOrderId: this.orderId, post: { orderRowId: this.orderRow.orderRowId, quantity: this.newQuantity}, popup: false }
			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_ORDER_ROW, data: data }).finally(() => {
				this.order.meta.updating = false
				this.spinner = false
				this.showChangeQuantity = false;

			})
		}

	},
	created(){
		
	}
};
</script>

<style scoped>

table tr td {
	padding:5px;
}




</style>